export const breakpointsConfig = {
  s: 400,
  m: 600,
  l: 924,
  xl: 1280,
  hd: 1800,
  mobile: 0,
  tablet: 923,
  desktop: 1279,
};
